import ProductDetailsContaint from "./../components/HeaderProductDetailsContaint";
import axios from "../../../common/utils/axios";
import KitService from "../../../common/services/kit/KitService";
import WatchlistService from "../../../common/services/kit/WatchlistService";
import {
    CREATE_WATCHLIST_RECORD,
    DELETE_WATCHLIST_RECORD,
    GET_SIMILAR,
    KIT_INC_VIEWS,
    KIT_CURRENCY,
    ADD_QUESTION,
    ADD_ANSWER,
    GET_KIT_QA,
    KIT_REGISTER_VIEWER
} from "./actions";
import {
    ADD_RECORD_TO_WATCHLIST,
    REMOVE_RECORD_FROM_WATCHLIST,
} from "../../../common/store/actions";

import { GET_CUSTOMER_WATCHLIST } from "../../userdashboard/store/watchlist/actions";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import AuthHelper from "../../../common/helpers/AuthHelper";

import { getCurrencies } from "./../../../common/api/currencies";
import KitQAService from "../../../common/services/kitQA/KitQAService";

export default {
    state: {
        displayProductDetails1: false,
        SelectProductId: "",
        showShare: false,
        productDetails: {
            generalInfo: {},
            images: [],
            images_full_size: [],
            details: [],
            description: "",
            specs: [],
            items: [],
            similarsItems: [],
            similiar: [],
            seller_Id: "",
            kitCurrency:null,
          

        },
        negotiationCurrency:{id: 1, name: "US Dollar", code: "USD", symbol: "$", rate: 1, created_at: null},
        main_images: {},

        displayProductDetails: true,

        productDetailsActiveComponent: ProductDetailsContaint,
        productActiveComponent: "DetailsSection",
    },
    getters: {
        negotiationCurrency: (state) => {
            return state.negotiationCurrency;
        },
        productActiveComponent: (state) => {
            return state.productActiveComponent;
        },
        showShare: (state) => {
            return state.showShare;
        },
        main_images: (state) => {
            return state.main_images;
        },
        productDetailsImages: (state) => {
            return state.productDetails.images;
        },
        productDetailsFullSizeImages: (state) => {
            return state.productDetails.images_full_size;
        },
        productDetails: (state) => {
            return state.productDetails;
        },
        description: (state) => {
            return state.productDetails.description;
        },
        kitId: (state) => {
            return state.productDetails.generalInfo.id;
        },
        details: (state) => {
            return state.productDetails.details;
        },

        specs: (state) => {
            return state.productDetails.specs;
        },
       
        similarsItems: (state) => {
            return state.productDetails.similarsItems;
        },
        productItemsDetails: (state) => {
            return state.productDetails.items;
        },
        productItemsSimiliar: (state) => {
            return state.productDetails.similiar;
        },

        productDetailsInfos: (state) => {
            return state.productDetails.generalInfo;
        },

        displayProductDetails1: (state) => {
            return state.displayProductDetails1;
        },

        productDetailsActiveComponent: (state) => {
            return state.productDetailsActiveComponent;
        },
        seller_Id: (state) => {
            return state.productDetails.seller_Id;
        },
        kitCurrency:(state)=>{
            return state.productDetails.kitCurrency;
        }
    },
    mutations: {
        setNegotiationCurrency: (state, data) => {
            state.negotiationCurrency = data;
        },
        setProductPrice: (state, data) => {
            state.productDetails.generalInfo = { price: data[0].price };
        },
        [GET_SIMILAR]: (state, data) => {
            state.productDetails.similarsItems = data;
        },
        setShowShare: (state) => {
            state.showShare = !state.showShare;
        },
        displayProductDetails1(state, ProductDisplay) {
            state.SelectProductId = ProductDisplay.id;
            state.displayProductDetails1 = ProductDisplay.option;
        },
        setMainImage(state, main_images) {
            state.main_images = main_images;
        },
        productDetailsActiveComponent(state, activeComponent) {
            state.productDetailsActiveComponent = activeComponent;
        },

        productDetails_generalInfo(state, generalInfo) {
            state.productDetails.generalInfo = generalInfo;
        },
        productDetails_images(state, images) {
            state.productDetails.images = images;
        },
        productDetails_images_full_size(state, images) {
            state.productDetails.images_full_size = images;
        },
        productDetails_description(state, description) {
            state.productDetails.description = description;
        },
        productDetails_details(state, details) {
            state.productDetails.details = details;
        },
        productDetails_items(state, items) {
            state.productDetails.items = items;
        },
        productDetails_specs(state, specs) {
            state.productDetails.specs = specs;
        },
        productDetails_similarsItems(state, similarsItems) {
            state.productDetails.similarsItems = similarsItems;
        },

        productDetails_similiar(state, similiar) {
            state.productDetails.similiar = similiar;
        },
        seller_Id(state, seller_Id) {
            state.productDetails.seller_Id = seller_Id;
        },
        productActiveComponent: (state, data) => {
            state.productActiveComponent = data;
        },
        [KIT_CURRENCY]: (state,data)=>{
            state.productDetails.kitCurrency = data
        },
        [GET_KIT_QA]: (state,data)=>{
            state.productDetails.generalInfo.kitQA = data
        }
    },
    actions: {
        getKitPrice: (context, data) => {
            var kitService = new KitService();
            kitService.getPriceKit(data).then((result) => {
                context.commit("setProductPrice", result.data.data);
            });
        },

        productActiveComponent(context, data) {
            if (!AuthHelper.checkAuthForAction(context)) return;
            context.commit("productActiveComponent", data);
        },
        productDetailsActiveComponent(context, activeComponent) {
            context.state.productDetailsActiveComponent = activeComponent;
        },
        displayProductDetails1: async(context, data) => {
            return new Promise(
                (resolve)=>
                {
                    context.dispatch("getProductDetails", data.id).then(() => {
                        resolve(context.commit("displayProductDetails1", {
                            option: data.option,
                            id: data.id,
                        }));
                    });
                }
            )
        },
        [KIT_INC_VIEWS]: async(context, id) => {
            var kitService = new KitService();
            var result = await kitService.views(id);
            return result;
        },
        [KIT_REGISTER_VIEWER]:async(context, id)=> {
            var kitService = new KitService();
            var result = await kitService.registerViewer(id);
            return result;
        },
        [GET_SIMILAR]: async(context, id) => {
            var kitService = new KitService();
            var result = await kitService.similar(id);
            context.commit(GET_SIMILAR, result.data.data.data);
            return result;
        },
        [DELETE_WATCHLIST_RECORD]: async(context, kitId) => {
            var watchlistService = new WatchlistService();
            var result = await watchlistService.deleteRecord(
                context.getters.customer.id,
                kitId
            );
            context.commit(REMOVE_RECORD_FROM_WATCHLIST, kitId);
            context.dispatch(GET_CUSTOMER_WATCHLIST);
            return result;
        },
        [CREATE_WATCHLIST_RECORD]: async(context, kitId) => {
            var watchlistService = new WatchlistService();
            var result = await watchlistService.create({
                kit_id: kitId,
                customer_id: context.getters.customer.id,
            }, {
                message: {
                    success: GeneralHelper.buildMessage(1, "Added to watchlist"),
                },
            });
            context.commit(ADD_RECORD_TO_WATCHLIST, result.data);
            return result;
        },
        [ADD_QUESTION]: async (context, data)=>
        {
            var kitQAService = new KitQAService()
            return await kitQAService.addQuestion(data)
        },
        [ADD_ANSWER]: async (context, data)=>
        {
            var kitQAService = new KitQAService()
            return await kitQAService.addAnswer(data)
        },
        [GET_KIT_QA]: async (context, id)=>
        {
            var kitQAService = new KitQAService()
            var response = await kitQAService.getKitQA(id)
            context.commit(GET_KIT_QA,response.data)
        },

        setMainImage() {
            let $images = this.getters.productDetailsImages;
            $images.forEach((element) => {
                if (element.is_main) {
                    this.commit("setMainImage", element);
                }
            });
        },

        getProductDetails: async(context, kitid) => {
            var kitService = new KitService();
            var kitQAService = new KitQAService();
            var response = await kitService.getById(kitid);
            var kitQAResponse = await kitQAService.getKitQA(kitid);
            context.commit('addToTranslations', response.data.data.translations)
            context.commit("productDetails_generalInfo", {
                kitCurrencyId: response.data.data.currency_id,
                youtubelink: response.data.data.youtubelink,
                sourceId: response.data.data.sourceId,
                availibilityId: response.data.data.availibilityId,
                is_draft: response.data.data.is_draft,
                sellerId: response.data.data.sellerId,
                isServiceCenter: response.data.data.is_service_center,
                isTrustedSeller: response.data.data.is_trusted_seller,
                isCertifiedSeller: response.data.data.is_certified_seller,
                nbSuccessfullSales: response.data.data.nb_successfull_sales,
                sellerDate: response.data.data.sellerDate,
                thumb_url: response.data.data.thumb_url,
                files: response.data.data.files,
                accessories: response.data.data.accessories,
                id: response.data.data.id,
                title: response.data.data.title,
                model: response.data.data.productName,
                brand: response.data.data.brandName,
                Category: response.data.data.categoryName,
                categoryId: response.data.data.categoryId,
                condition: response.data.data.conditionName,
                price: response.data.data.cprice,
                salesPrice: response.data.data.salesCprice,
                salesPercentage: response.data.data.salesPercentage,
                originalPrice:response.data.data.price,
                originalCurrencySymbol:response.data.data.currencySymbol,
                currency: context.getters.currency.symbol,
                store: response.data.data.sourceName,
                estimatedTime: response.data.data.sourceEstimation,
                year: response.data.data.itemYear,
                country: response.data.data.country,
                quantity: response.data.data.quantity,
                views: response.data.data.views,
                watch_list: response.data.data.watch_list,
                kitQA: kitQAResponse.data,
                customSpecs: JSON.parse(response.data.data.custom_specs),
                is_negotiable: response.data.data.is_negotiable, 
                is_featured: response.data.data.is_featured

            });
            

            let currenciesAPI = await getCurrencies()
            let currencies =  currenciesAPI.data.data

            let kitCurrencyId = context.getters.productDetails.generalInfo.kitCurrencyId
            let kitCurrency;
        

            currencies.forEach(function(currency)
            {
                if(currency.id==kitCurrencyId)
                {
                    kitCurrency = currency
                }
            })

            localStorage.setItem('kitCurrency', JSON.stringify(kitCurrency));
            context.state.productDetails.kitCurrency= kitCurrency
            context.commit("productDetails_details", [
                { type: "Brand", value: response.data.data.brandName },
                { type: "Model", value: response.data.data.productName },
                { type: "Year", value: response.data.data.itemYear },
                {
                    type: "Warranty",
                    value: response.data.data.warranty == 0 ?
                        "No Warranty" :
                        response.data.data.warranty + " months",
                },
            ]);
            context.commit(
                "productDetails_description",
                response.data.data.description
            );
            context.commit("displayProductDetails1", { option: true, id: kitid });
            context.commit("seller_Id", response.data.data.seller_id);
            context.commit("productDetails_items", response.data.data.items);
            context.commit("productDetails_images", response.data.data.images);
            context.commit("productDetails_images_full_size", response.data.data.images_full_size);
            context.commit(
                "productDetails_similarsItems",
                response.data.data.similiar_kits
            );
            context.commit("productDetails_similiar", response.data.data.similiar);
            let kitViews_kit_id = { kit_id: response.data.data.id };
        },
        saveSeller: ({ commit }, save_seller_id) => {
            let save_sellerId = { seller_id: save_seller_id };
            return new Promise((resolve, reject) => {
                axios({
                        url: "/customer/savedsellers",
                        data: save_sellerId,
                        method: "POST",
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        sameSeller: ({ commit }, kit_id) => {
            let same_kit_id = { kit_id: kit_id };
            return new Promise((resolve, reject) => {
                axios({
                        url: "/kit/sameSeller",
                        data: same_kit_id,
                        method: "POST",
                        authorization: false,
                    })
                    .then((response) => {
                        commit("equipementsList", response.data.data);
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};